import styled from '@emotion/styled'
import { Button, Col, ChipTagMenu, Row } from 'components/patterns'

export const StyledRow = styled(Row)`
  gap: 12px;
  margin-left: 0 !important;
  margin-right: 0 !important;
`

export const StyledFilterItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: fit-content;
`

export const StyledChipTagMenu = styled(ChipTagMenu)`
  flex-wrap: nowrap;
  height: 32px;
`

export const StyledInputCol = styled(Col)`
  margin-top: 10px;
  padding-left: 0 !important;
  padding-right: 0 !important;
`

export const SearchFeaturesLabel = styled.span`
  white-space: nowrap;
  color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.7));
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Arial;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`

export const StyledAutoCol = styled(Col)`
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
`

export const StyledButtonCol = styled(Col)`
  padding-left: 0 !important;
  padding-right: 0 !important;
`

export const StyledButton = styled(Button)`
  margin: 0 !important;
`
